import {observer} from "mobx-react";
import React from "react";
import {ExpandComponentProps} from "../../core/grid/component/gridComp";
import {loc} from "../../core/common/config/locales";
import ProjectVersionDoor from "../domain/project/projectVersionDoorDomain";


@observer
export default class ProjectVersionDoorMaterialExpandComp extends React.Component<ExpandComponentProps, any> {

  render(): JSX.Element | false | null {

    const {item} = this.props;
    const door = item.rowObject as ProjectVersionDoor;

    return (
      <div>
        {
          door.frameMaterial &&
            <div>
              <p>{loc.i18n`Frame material`}</p>
              <ul>
                <li>{door.frameMaterial.label} : {door.frameMaterialMass} kg</li>
              </ul>
            </div>
        }
        {
          (door.leafMaterial1 || door.leafMaterial2 || door.leafMaterial3) &&
            <div>
              <p>{loc.i18n`Leaf materials`}</p>
              <ul>
                {door.leafMaterial1 && <li>{door.leafMaterial1.label} : {door.leafMaterial1Mass} kg</li>}
                {door.leafMaterial2 && <li>{door.leafMaterial2.label} : {door.leafMaterial2Mass} kg</li>}
                {door.leafMaterial3 && <li>{door.leafMaterial3.label} : {door.leafMaterial3Mass} kg</li>}
              </ul>
            </div>
        }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionDoorMaterialExpandComp.tsx